import { usePathname, useRouter } from 'next/navigation';

import type {
  MainModalController} from '@uikit';
import {
  HorizontalSeparator,
  Modal,
  ModalCloseButton,
  ModalContent,
} from '@uikit';

import Checked from '@uikit/icons/Checked';

import NextLink from '@shared/common/components/NextLink';

export interface HotOfferSuccessModalProps {
  modalController: MainModalController;
}

export default function HotOfferSuccessModal({
  modalController: modal,
}: HotOfferSuccessModalProps) {
  const pathname = usePathname();
  const router = useRouter();

  const handleOnOpenChange = (value: boolean) => {
    router.replace(pathname);

    modal.props.onOpenChange(value);
  };

  const modalProps = { ...modal.props, onOpenChange: handleOnOpenChange };

  return (
    <Modal {...modalProps}>
      <ModalContent className="items-center p-0">
        <ModalCloseButton className="m-4" />

        <div className="flex flex-col items-center p-10 pt-0">
          <div className="flex items-center justify-center w-[40px] aspect-square bg-green-600 rounded-full">
            <Checked className="icon text-neutral-50" />
          </div>

          <h5 className="text-green-600 t-h4 text-xl">Congratulations!</h5>

          <HorizontalSeparator className="my-6" lineClassName="!bg-neutral-300" />

          <p className="t-body2 text-neutral-400 text-center">
            Token purchase successful!
            <br />
            You’ve unlocked your Cash Back reward.
            <br />
            Check your email for more info.
          </p>

          <NextLink
            className="rounded-full mt-6 p-5 h-[60px] w-full flex items-center justify-center border border-secondary-600 text-secondary-600 t-body2"
            href="/hot-offers?sortBy=cashback"
          >
            Explore More Cash-Back Offers
          </NextLink>
        </div>
      </ModalContent>
    </Modal>
  );
}
